import { Card, CardBody, Col, CardHeader, Container, FormGroup, Input, Row, Table } from "reactstrap";
import { Btn, H4, H6, LI, P, UL } from "../../AbstractElements";
import { formatPrice, maskItem, URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPhoneNumber, itemHasPermission } from "../../utils/helper/helpers";
import SweetAlert from 'sweetalert2';
import { Link } from "react-router-dom";
import { deleteBonCommande, } from "./apiBon";
import { AddClient, UpdateStatusBons } from "../../utils/helper/modal";
import Chart from "../versements_v2/apiVersement";
import useInfosEts from "../InfosEts/InfoApi";

// Types
type Tableau = { [key: string]: any };

interface BonsAggregated {
    qts: number;
    qtt: number;
    mt: number;
    name: string;
}

interface BonsForms {
    success: boolean;
    diamond: BonsAggregated;
    cimaf: BonsAggregated;
    ciment_de_guinee: BonsAggregated;
    diamond_sougueta: BonsAggregated;
    bons: Tableau[];
    etablissements: Tableau[];
    [key: string]: BonsAggregated | Tableau[] | boolean | []
}

const GestBonsA = () => {
    const [refresh, setRefresh] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Tableau[]>([]);
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [etsFilter, setEtsFilter] = useState<string>("");
    const infosEts = useInfosEts(refresh) || [];
    const [data, setData] = useState<BonsForms | null>({
        success: false,
        diamond: { qts: 0, qtt: 0, mt: 0, name: "" },
        cimaf: { qts: 0, qtt: 0, mt: 0, name: "" },
        ciment_de_guinee: { qts: 0, qtt: 0, mt: 0, name: "" },
        diamond_sougueta: { qts: 0, qtt: 0, mt: 0, name: "" },
        bons: [],
        etablissements: [],
    });
    const [chartData, setChartData] = useState<number[]>([0, 0, 0]);
    const [cimafStockDisponible, setCimafStockDisponible] = useState<number>(0);
    

    // Récupération initiale des filtres sauvegardés
    useEffect(() => {
        const savedFilterText = localStorage.getItem("filterText_bon") || "";
        const savedSelectedMonth = localStorage.getItem("selectedMonth_bon");
        const savedEtsFilter = localStorage.getItem("etsFilter_bon") || "";

        setFilterText(savedFilterText);
        setSelectedMonth(savedSelectedMonth ? parseInt(savedSelectedMonth) : null);
        setEtsFilter(savedEtsFilter);
    }, []);

    // Sauvegarde des filtres dans localStorage à chaque changement
    useEffect(() => {
        localStorage.setItem("filterText_bon", filterText);
        localStorage.setItem("selectedMonth_bon", selectedMonth ? selectedMonth.toString() : "");
        localStorage.setItem("etsFilter_bon", etsFilter);
    }, [filterText, selectedMonth, etsFilter]);

    // Bouton pour réinitialiser les filtres
    const clearFilters = () => {
        localStorage.removeItem("filterText_bon");
        localStorage.removeItem("selectedMonth_bon");
        localStorage.removeItem("etsFilter_bon");

        setFilterText("");
        setSelectedMonth(null);
        setEtsFilter("");
    };

    const fetchVersements = useCallback(async () => {
        const Token = JSON.parse(localStorage.getItem("login")!);
        try {
            const response = await axios.get(`${URL_API}/bon/all`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                console.log('cimaf', response.data);

                setData(response.data);
                setChartData([
                    response.data.diamond.qtt ?? 0,
                    response.data.diamond_sougueta.qtt ?? 0,
                    // response.data.cimaf.qtt ?? 0,
                    response.data.ciment_de_guinee.qtt ?? 0,
                ]);
                setCimafStockDisponible(response.data.cimaf.qtt ?? 0);

            }
        } catch (error: any) {
            console.log(error);
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    const [modal, setModal] = useState(false);
    const [modalClient, setModalClient] = useState(false);
    const [bonsId, setBonsId] = useState<number>();
    const staticModalToggle = () => setModal(!modal);
    const staticModalClientToggle = () => setModalClient(!modalClient);

    const openModalWithRow = (id: number) => {
        setBonsId(id);
        setModal(true);
    };

    const openModalClient = (id: number) => {
        setBonsId(id);
        setModalClient(true);
    };

    const filterByEts = (bons: Tableau[], code: string) => {
        if (!code) return bons;
        const transformCode = code.toLocaleLowerCase();
        return bons.filter((item) => item.ets_code?.toLowerCase().includes(transformCode));
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1;
        let filtered = data?.bons || [];

        filtered = filtered.filter((item) => {
            const itemMonth = new Date(item.date_bons).getMonth() + 1;
            const matchesMonth = filterText ? true : selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = (
                item.immatriculation?.toLowerCase().includes(filterText.toLowerCase()) ||
                item.ets_nom?.toLowerCase().includes(filterText.toLowerCase()) ||
                item.num?.toLowerCase().includes(filterText.toLowerCase()) ||
                item.nom_client?.toLowerCase().includes(filterText.toLowerCase()) ||
                item.destination?.toLowerCase().includes(filterText.toLowerCase()) ||
                item.date_bons?.toLowerCase().includes(filterText.toLowerCase())
            );

            return matchesMonth && matchesSearch;
        });

        const finalFiltered = filterByEts(filtered, etsFilter);
        setFilteredItems(finalFiltered);
    }, [data?.bons, filterText, selectedMonth, refresh, etsFilter]);

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    const Confirmation = ({ id }: { id: number }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir Supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteBonCommande({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    useEffect(() => {
        fetchVersements();
    }, [refresh, fetchVersements]);

    const isFiltered = filterText !== "" || selectedMonth !== null || etsFilter !== "";

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Bons de commande" parent="Gestions" />
            <Container fluid>
                <Row>
                    
                    <Col md={4} lg={3}>
                        <Card className="total-project">
                            <CardBody className="p-0">
                                {chartData && <Chart chartData={chartData} />}

                                <UL className="project-details simple-list">
                                    <Card className="progress-items bg-light-success mb-0">
                                        <CardHeader className="p-2 bg-light-success">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        DIAMOND KAGBLEN
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.diamond.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-info mb-1">
                                        <CardHeader className="p-2 bg-light-info">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        DIAMOND SOUGUETA
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.diamond_sougueta.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-warning mb-1">
                                        <CardHeader className="p-2 bg-light-warning">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        CIMENT DE GUINEE
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.ciment_de_guinee.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-dark m-0">
                                        <CardHeader className="p-2 bg-light-dark">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        CIMAF
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{maskItem(formatPrice(cimafStockDisponible))}</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    
                                </UL>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={8} lg={9}>
                        <Row>
                            {
                                data?.etablissements.map((item, index) => (
                                    <Col md={12} lg={12} key={index}>
                                        <Card className="progress-items pb-0 bg-light-info">
                                            <CardHeader className="pb-4 bg-light-info">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <Link to={'#'} className="text-dark">

                                                            <H4>
                                                                <span className="text-dark fw-bold">{item.nom}</span>
                                                            </H4>
                                                            <span>{item.code}</span>
                                                        </Link>

                                                        <H6 className="f-20 f-w-600 mt-3">
                                                            {item.versement_count} Achats
                                                        </H6>
                                                    </div>
                                                    <div className="d-md-none d-lg-inline">
                                                        <i className="icofont icofont-bricks f-80"></i>
                                                    </div>
                                                </div>
                                            </CardHeader>
                                        </Card>
                                    </Col>
                                ))
                            }
                        </Row>
                    </Col>
                    <Col md="12">
                        <Card >
                            <CardBody className="mb-0">
                                <Row>
                                    <Col sm='9'>
                                        <Row>
                                            <Col sm="12" className="mb-2">
                                                <div className="dataTables_filter d-flex align-items-center">
                                                    <Input
                                                        type="search"
                                                        placeholder="Recherche..."
                                                        value={filterText}
                                                        onChange={(e) => setFilterText(e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm="6" className="mt-2">
                                                <Input name="type" value={selectedMonth || ''} onChange={handleMonthChange} className="form-control" type="select">
                                                    <option value="">Mois actuel</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </Input>
                                            </Col>
                                            <Col sm="6" className="mt-2">
                                                <FormGroup>
                                                    <Input
                                                        type="select"
                                                        className="form-control"
                                                        id="ets"
                                                        value={etsFilter}
                                                        onChange={(e) => setEtsFilter(e.target.value)}
                                                    >
                                                        <option value=''>Etablissement...</option>
                                                        {infosEts.map((item, index) => {
                                                            if (item.status === 'actif' && item.type === 'Personnel') {
                                                                return <option key={index} value={item.code}>{item.nom}</option>;
                                                            }
                                                            return null;
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col sm="3">
                                        {
                                            (itemHasPermission('super admin') || itemHasPermission('gest. bons ecriture')) && (
                                                <>
                                                    <Link to="/nouveau-bon-de-commande" className="btn btn-light-dark for-light w-100 my-2">
                                                        <i className="fa fa-plus"></i> Faire un bon de commande
                                                    </Link>
                                                    <Link to="/nouveau-bon-de-commande" className="btn btn-light-light for-dark w-100 my-2">
                                                        <i className="fa fa-plus"></i> Faire un bon de commande
                                                    </Link>
                                                </>
                                            )
                                        }
                                        <Btn color="danger" className="w-100 my-2" onClick={clearFilters} disabled={!isFiltered}>
                                            <i className="fa fa-times"></i> Réinitialiser
                                        </Btn>
                                        
                                    </Col>
                                    
                                </Row>
                            </CardBody>
                        </Card>
                        <Table responsive id="all-invoice" striped={true}>
                            <thead className="bg-info">
                                <tr>
                                    <th className="text-white">Id</th>
                                    <th className="text-white">Etablissement & No Bons</th>
                                    <th className="text-white ">Destination</th>
                                    <th className="text-white ">Client</th>
                                    <th className="text-white ">Téléphone</th>
                                    <th className="text-white ">Immatriculations</th>
                                    <th className="text-white ">status</th>
                                    <th className="text-white ">Actions</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item, index) => (
                                    <tr key={index}>
                                        <th scope='row'>
                                            <span className="fw-bold">
                                                #{index + 1}
                                            </span>
                                        </th>
                                        <td >
                                            <span className="fw-bold text-capitalize">
                                                {item.ets_nom}
                                            </span> <br></br>
                                            <span>
                                                {item.num}
                                            </span>
                                        </td>
                                        <td >
                                            <span className="fw-bold text-capitalize">
                                                {item.destination}
                                            </span>
                                        </td>
                                        <td >
                                            {(itemHasPermission('super admin') || itemHasPermission('gest. bons ecriture')) ? (
                                                item.nom_client ? (
                                                    <>
                                                        <span className="fw-bold text-capitalize">
                                                            {item.nom_client}
                                                        </span>
                                                        <Btn className='btn btn-xs btn-light-danger mx-1 my-1' onClick={() => openModalClient(item.id)} >
                                                            Modifier
                                                        </Btn>
                                                    </>
                                                ) : (
                                                    <Btn className='btn btn-xs btn-light-info mx-1 my-1' onClick={() => openModalClient(item.id)} >
                                                        Ajouter
                                                    </Btn>
                                                )

                                            ) : (
                                                <span className='text-info fw-bold mx-1 my-1' >
                                                    {item.nom_client ? item.nom_client : 'Aucun'}
                                                </span>
                                            )}
                                        </td>
                                        <td >
                                            <span className="fw-bold text-capitalize">
                                                {formatPhoneNumber(item.telephone)}
                                            </span>
                                        </td>
                                        <td >
                                            <span className="fw-bold text-capitalize">
                                                {formatPhoneNumber(item.immatriculation)}
                                            </span>
                                        </td>
                                        <td>
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. bons ecriture')) ? (
                                                    <Btn className='btn btn-xs btn-light-danger mx-1 my-1' onClick={() => openModalWithRow(item.id)} >
                                                        {item.bons_status !== 'actif' ? item.bons_status : 'Nouveau'}
                                                    </Btn>
                                                ) : (
                                                    <span className='text-danger fw-bold mx-1 my-1' >
                                                        {item.bons_status !== 'actif' ? item.bons_status : 'Nouveau'}
                                                    </span>
                                                )
                                            }
                                        </td>
                                        <td>
                                            <Link className='btn bg-light-dark btn-xs mx-1 my-1 for-light' to={`/show-bon-de-commande/${item.id}`}>
                                                <i className='fa fa-eye'></i>
                                            </Link>
                                            <Link className='btn btn-light-light btn-xs mx-1 my-1 for-dark' to={`/show-bon-de-commande/${item.id}`}>
                                                <i className='fa fa-eye'></i>
                                            </Link>

                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. bons ecriture')) && (

                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id })}>
                                                        <i className='fa fa-trash'></i>
                                                    </Btn>

                                                )
                                            }
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        {
                            UpdateStatusBons({
                                isOpen: modal,
                                bons_id: bonsId ?? null,
                                toggle: staticModalToggle,
                            }, () => setRefresh(!refresh))
                        }{
                            AddClient({
                                isOpen: modalClient,
                                bons_id: bonsId ?? null,
                                toggle: staticModalClientToggle,
                            }, () => setRefresh(!refresh))
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default GestBonsA